var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoquantum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 123,
    viewBox: "0 0 132 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_3929)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2998,
    y: 25.2998,
    width: 72.5,
    height: 64,
    rx: 20,
    fill: "#113031",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7998,
    y: 25.7998,
    width: 71.5,
    height: 63,
    rx: 19.5,
    stroke: "url(#paint0_linear_21_3929)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9738 44.6234L67.5537 41.3036C66.5774 40.9652 64.9846 40.9652 64.0083 41.3036L54.5883 44.6234C52.7728 45.268 51.2998 47.2663 51.2998 49.0874V62.1408C51.2998 63.4462 52.2076 65.1705 53.3208 65.944L62.7409 72.5675C64.4023 73.7439 67.1255 73.7439 68.7869 72.5675L78.207 65.944C79.3203 65.1544 80.2282 63.4462 80.2282 62.1408V49.0874C80.2454 47.2663 78.7722 45.268 76.9738 44.6234ZM67.057 58.6438V62.8821C67.057 63.5429 66.4747 64.0908 65.7725 64.0908C65.0702 64.0908 64.4879 63.5429 64.4879 62.8821V58.6438C62.758 58.1281 61.4907 56.6132 61.4907 54.8244C61.4907 52.6005 63.4089 50.7956 65.7725 50.7956C68.136 50.7956 70.0543 52.6005 70.0543 54.8244C70.0543 56.6293 68.7869 58.1281 67.057 58.6438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_3929",
    x: -0.00019455,
    y: -0.00019455,
    width: 131.1,
    height: 122.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.32549 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_3929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_3929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_3929",
    x1: 65.5498,
    y1: 89.2998,
    x2: 65.5498,
    y2: 25.2998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoquantum);
export default __webpack_public_path__ + "static/media/icon-goquantum.585b07153bb9459eee92bb78d8ab7438.svg";
export { ForwardRef as ReactComponent };